import dateformat from 'dateformat';
import { isPastNumberOfDays } from './is-past-number-of-days';
import sendDataToNewrelic from '@stencil/send-data-to-new-relic';

export default function getDateObject(dateObj, isPastNumberOfDaysCheck = true) {
  try {
    if (!dateObj) {
      return null;
    }
    let date = new Date(dateObj);
    if (isPastNumberOfDaysCheck && isPastNumberOfDays(date, 0)) {
      date = new Date();
    }
    return {
      dateObj: date,
      dateToDisplay: dateformat(date, "dd mmm 'yy"),
      yyyymmdd: dateformat(date, 'yyyymmdd'),
      day: dateformat(date, 'dddd'),
      monthToDisplay: dateformat(date, "mmmm 'yy"),
      'yyyy-mm-dd': dateformat(date, 'yyyy-mm-dd'),
      dddddmmm: dateformat(date, 'ddd, dd mmm'),
      ddmmm: dateformat(date, 'dd mmm'),
      yyyymm: dateformat(date, 'yyyymm'),
      yy: dateformat(date, 'yy'),
      dateWithTime: dateformat(date, 'mmm dd, yyyy,'),
      ddmmyyyy: dateformat(date, 'ddmmyyyy'),
      dateForRS: dateformat(date, 'dd-mm-yyyy hh:mm:ss')
      // ddmmyyyy: dateformat(date, 'ddmmyyyy'),
      // 'dd-mm-yyyy': dateformat(date, 'dd-mm-yyyy')
    };
  } catch (err) {
    sendDataToNewrelic('GetDateObject', `Failed with error: ${err}`);
  }
}
